export const BACKEND_URL = "https://mystic-column-387705.wl.r.appspot.com";
// export const BACKEND_URL = "http://localhost:5000";
